import { z } from "zod";
import api from "./api";

const inputSchema = z.object({
  name: z.string(),
  description: z.string(),
  value: z.string(),
});

export async function createKb(data: Partial<z.infer<typeof inputSchema>>) {
  const result = inputSchema.safeParse(data);
  if (!result.success) {
    throw new Error(result.error.errors[0].message);
  }

  const response = await api.post("/knowledge/base", data);
  return response.data;
}
